// import React, { useState, useRef, useEffect } from 'react';
// <link
//   rel="stylesheet"
//   href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
// />

// const InputBoxSmall = ({ 
//   label, 
//   defaultValue = '', 
//   onChange, 
//   type = 'text', 
//   validators = [], 
//   name,
//   startDate,
//   disablePastDates,
//   disableFutureDates,
//   isRequired = false,
//   readOnly = false,
//   className='',
//   border='',
//   error,
// }) => {
//   const [value, setValue] = useState(defaultValue);
//   const [errors, setErrors] = useState([]);
//   const dateInputRef = useRef(null);

//   useEffect(() =>{
//       setValue(defaultValue)
//     },[defaultValue])


// useEffect(() => {
//     if (startDate && type === 'small-date' && value) {
      
//       setErrors([])

//       const valueDate = new Date(value);
//       const minDate = new Date(startDate);
      
//       if (valueDate < minDate) {
//         setValue('');
//         if (onChange) {
//           const syntheticEvent = {
//             target: {
//               name,
//               value: ''
//             }
//           };
//           onChange(syntheticEvent);
//         }
//         setErrors("Select a valid date")
//       }
      
//     }
//   }, [startDate,value]);

//   const validatorArray = Array.isArray(validators) 
//     ? validators 
//     : (validators ? [validators] : []);

//   const effectiveValidators = isRequired 
//     ? [
//       ...(typeof validatorArray === 'function' ? [validatorArray] : validatorArray),
//       (val) => val !== null && val !== undefined && val !== '' || "This field is required"
//     ]
//     : validatorArray;

//   const validateInput = (inputValue) => {
//     const newErrors = effectiveValidators
//       .map((validator) => {
//         if (typeof validator === 'function') {
//           const result = validator(inputValue);
//           return result === true ? null : result;
//         }
//         return null;
//       })
//       .filter((error) => typeof error === 'string');

//     return newErrors;
//   };

//   const handleInputChange = (event) => {
//     const newValue = event.target.value;
    
//     const newErrors = validateInput(newValue);
    
//     setValue(newValue);
//     setErrors(newErrors);

//     if (onChange) {
//       onChange(event);
//     }
//   };
  

//   const handleCalendarIconClick = () => {
//     if (dateInputRef.current) {
//       dateInputRef.current.showPicker();
//     }
//   };

//   const today = new Date().toISOString().split("T")[0];

//   const getMinDate = () => {
//     if (startDate) {
//       return startDate;
//     } else if (disablePastDates) {
//       return today;
//     }
//     return undefined;
//   };

//   const displayErrors = error ? [error] : errors;

//   return (
//     <div className={`small-input-box-container w-100 ${className}`}>
//       <input
//         className={`input-box fts-15 common-text ftw-4 ${
//           type === 'date' ? 'input-box-with-icon hide-native-icon' : ''
//         } ${errors.length > 0 ? 'input-error' : ''} ${border}`}
//         type={type === 'small-date' ? 'date' : type}
//         value={value}
//         onChange={handleInputChange}
//         placeholder=''
//         ref={type === 'small-date' ? dateInputRef : null}
//         name={name}
//         readOnly={readOnly}
//         min={getMinDate()}
//         max={disableFutureDates ? today : undefined}
//       />
//       <label className={`input-date-label input-label fts-15 common-text ftw-4 ${value ? 'has-value' : ''} ${type === 'small-date' ? 'small-date-label' : ''}`}>
//         {label}
//       </label>
//       {type === 'date' && (
//         <div className='calendar-icon' onClick={handleCalendarIconClick}>
//           <svg className='custom-calendar-icon' width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
//              <path d="M17.8125 1.87104L13.0583 1.87106V0.625146C13.0583 0.279753 12.7926 0 12.4646 0C12.1365 0 11.8708 0.279753 11.8708 0.625146V1.87075H7.12084V0.625146C7.12084 0.279753 6.85514 0 6.52709 0C6.19905 0 5.93334 0.279753 5.93334 0.625146V1.87075H1.1875C0.531703 1.87075 0 2.43057 0 3.12104V18.7497C0 19.4402 0.531703 20 1.1875 20H17.8125C18.4683 20 19 19.4402 19 18.7497V3.12104C19 2.43086 18.4683 1.87104 17.8125 1.87104ZM17.8125 18.7497H1.1875V3.12104H5.93334V3.75088C5.93334 4.09625 6.19905 4.37603 6.52709 4.37603C6.85514 4.37603 7.12084 4.09625 7.12084 3.75088V3.12136H11.8708V3.75119C11.8708 4.09658 12.1365 4.37634 12.4646 4.37634C12.7926 4.37634 13.0583 4.09658 13.0583 3.75119V3.12136H17.8125V18.7497ZM13.6562 9.99795H14.8438C15.1715 9.99795 15.4375 9.71788 15.4375 9.3728V8.12251C15.4375 7.77743 15.1715 7.49736 14.8438 7.49736H13.6562C13.3285 7.49736 13.0625 7.77743 13.0625 8.12251V9.3728C13.0625 9.71788 13.3285 9.99795 13.6562 9.99795ZM13.6562 14.9988H14.8438C15.1715 14.9988 15.4375 14.7191 15.4375 14.3737V13.1234C15.4375 12.7783 15.1715 12.4982 14.8438 12.4982H13.6562C13.3285 12.4982 13.0625 12.7783 13.0625 13.1234V14.3737C13.0625 14.7194 13.3285 14.9988 13.6562 14.9988ZM10.0938 12.4982H8.90625C8.5785 12.4982 8.3125 12.7783 8.3125 13.1234V14.3737C8.3125 14.7191 8.5785 14.9988 8.90625 14.9988H10.0938C10.4215 14.9988 10.6875 14.7191 10.6875 14.3737V13.1234C10.6875 12.7786 10.4215 12.4982 10.0938 12.4982ZM10.0938 7.49736H8.90625C8.5785 7.49736 8.3125 7.77743 8.3125 8.12251V9.3728C8.3125 9.71788 8.5785 9.99795 8.90625 9.99795H10.0938C10.4215 9.99795 10.6875 9.71788 10.6875 9.3728V8.12251C10.6875 7.77712 10.4215 7.49736 10.0938 7.49736ZM5.34375 7.49736H4.15625C3.8285 7.49736 3.5625 7.77743 3.5625 8.12251V9.3728C3.5625 9.71788 3.8285 9.99795 4.15625 9.99795H5.34375C5.6715 9.99795 5.9375 9.71788 5.9375 9.3728V8.12251C5.9375 7.77712 5.6715 7.49736 5.34375 7.49736ZM5.34375 12.4982H4.15625C3.8285 12.4982 3.5625 12.7783 3.5625 13.1234V14.3737C3.5625 14.7191 3.8285 14.9988 4.15625 14.9988H5.34375C5.6715 14.9988 5.9375 14.7191 5.9375 14.3737V13.1234C5.9375 12.7786 5.6715 12.4982 5.34375 12.4982Z" fill="#424242"/>
//           </svg>
//         </div>
//       )}
//       {displayErrors.length > 0 && (
//         <div className="input-error-message fts-12">
//           {displayErrors}
//         </div>
//       )}
//     </div>
//   );
// };

// export default InputBoxSmall;

import React, { useState, useRef, useEffect } from 'react';

const InputBoxSmall = ({ 
  label, 
  defaultValue = '', 
  onChange, 
  type = 'text', 
  validators = [], 
  name,
  cnf_password,
  startDate,
  disablePastDates,
  disableFutureDates,
  isRequired = false,
  readOnly = false,
  className='',
  border='',
  error,
  maxLength,
  numericType = "none"
}) => {
  const [value, setValue] = useState(defaultValue);
  const [errors, setErrors] = useState([]);
  const dateInputRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);
  const hasMountedCnf = useRef(false);

  useEffect(() =>{
      setValue(defaultValue)
    },[defaultValue])



  useEffect(() => {
    if (startDate && type === 'small-date' && value) {
      
      setErrors([])

      const valueDate = new Date(value);
      const minDate = new Date(startDate);
      
      if (valueDate < minDate) {
        setValue('');
        if (onChange) {
          const syntheticEvent = {
            target: {
              name,
              value: ''
            }
          };
          onChange(syntheticEvent);
        }
        setErrors("Select a valid date")
      }
      
    }
  }, [startDate,value]);


  const validatorArray = Array.isArray(validators) 
    ? validators 
    : (validators ? [validators] : []);

  const effectiveValidators = isRequired 
    ? [
      ...(typeof validatorArray === 'function' ? [validatorArray] : validatorArray),
      (val) => val !== null && val !== undefined && val !== '' || "This field is required"
    ]
    : validatorArray;

  const validateInput = (inputValue) => {
    const newErrors = effectiveValidators
      .map((validator) => {
        if (typeof validator === 'function') {
          const result = validator(inputValue);
          return result === true ? null : result;
        }
        return null;
      })
      .filter((error) => typeof error === 'string');

    return newErrors;
  };

  const handleInputChange = (event) => {
    let newValue = event.target.value;

    if (numericType === "integer") {
      newValue = newValue.replace(/\D/g, '');
    }

    if (numericType === "decimal") {
      newValue = newValue.replace(/[^0-9.]/g, '');
    }

    const newErrors = validateInput(newValue);

    setValue(newValue);
    setErrors(newErrors);

    if (onChange) {
      onChange({
        ...event,
        target: { ...event.target, value: newValue }
      });
    }
  };

  const handleKeyDown = (e) => {
    if (numericType === "none") return;

    const allowed = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];

    if (numericType === "integer") {
      if (!/[0-9]/.test(e.key) && !allowed.includes(e.key)) {
        e.preventDefault();
      }
    }

    if (numericType === "decimal") {
      if (!/[0-9.]/.test(e.key) && !allowed.includes(e.key)) {
        e.preventDefault();
      }

      if (e.key === '.' && e.target.value.includes('.')) {
        e.preventDefault();
      }
    }
  };
  

  const handleCalendarIconClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker();
    }
  };

  const today = new Date().toISOString().split("T")[0];

  const getMinDate = () => {
    if (startDate) {
      return startDate;
    } else if (disablePastDates) {
      return today;
    }
    return undefined;
  };

  const displayErrors = error ? [error] : errors;

  const actualType = type === 'password' ? (showPassword ? 'text' : 'password') : (type === 'small-date' ? 'date' : type);

  return (
    
    <div className={`small-input-box-container w-100 ${className}`}>
      <input
        className={`input-box fts-15 common-text ftw-4 ${
          type === 'date' ? 'input-box-with-icon hide-native-icon' : ''
        } ${errors.length > 0 ? 'input-error' : ''} ${border}`}
        type={actualType}
        value={value}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        placeholder=''
        ref={type === 'small-date' ? dateInputRef : null}
        name={name}
        readOnly={readOnly}
        min={getMinDate()}
        max={disableFutureDates ? today : undefined}
        autoComplete="off"
        autoCorrect="off"
        spellCheck="false"
        maxLength={maxLength}
      />
      <label className={`input-date-label input-label fts-15 common-text ftw-4 ${value ? 'has-value' : ''} ${type === 'small-date' ? 'small-date-label' : ''}`}>
        {label}
      </label>
      {type === 'password' && (
        <div
          className='eye-icon'
          onClick={() => setShowPassword(prev => !prev)}
          style={{ cursor: 'pointer' }}
        >
          {showPassword ? (
            // Eye icon (Password visible)
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M1.7181 10.29C1.64865 10.1029 1.64865 9.8971 1.7181 9.71C2.39452 8.06988 3.5427 6.66754 5.01708 5.68075C6.49146 4.69397 8.22564 4.16718 9.99977 4.16718C11.7739 4.16718 13.5081 4.69397 14.9825 5.68075C16.4568 6.66754 17.605 8.06988 18.2814 9.71C18.3509 9.8971 18.3509 10.1029 18.2814 10.29C17.605 11.9301 16.4568 13.3325 14.9825 14.3193C13.5081 15.306 11.7739 15.8328 9.99977 15.8328C8.22564 15.8328 6.49146 15.306 5.01708 14.3193C3.5427 13.3325 2.39452 11.9301 1.7181 10.29Z" stroke="#6D6D6D" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke="#6D6D6D" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          ) : (
            // Eye-off icon (Password hidden)
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M8.94434 4.23C10.8855 3.99867 12.849 4.40902 14.5351 5.39838C16.2211 6.38774 17.537 7.90173 18.2818 9.70917C18.3513 9.89627 18.3513 10.1021 18.2818 10.2892C17.9756 11.0317 17.5708 11.7296 17.0785 12.3642" stroke="#6D6D6D" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M11.7368 11.7983C11.2653 12.2537 10.6338 12.5057 9.97828 12.5C9.32278 12.4943 8.69575 12.2314 8.23223 11.7679C7.76871 11.3044 7.50579 10.6773 7.50009 10.0218C7.4944 9.36635 7.74638 8.73484 8.20178 8.26334" stroke="#6D6D6D" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M14.5656 14.5825C13.4602 15.2373 12.2268 15.6467 10.9492 15.7828C9.67165 15.919 8.37973 15.7787 7.16113 15.3716C5.94253 14.9644 4.82576 14.2999 3.88661 13.4231C2.94746 12.5463 2.2079 11.4778 1.7181 10.29C1.64865 10.1029 1.64865 9.89709 1.7181 9.71C2.45696 7.91821 3.757 6.41437 5.4231 5.42416" stroke="#6D6D6D" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M1.6665 1.66666L18.3332 18.3333" stroke="#6D6D6D" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </div>
      )}
      {type === 'date' && (
        <div className='calendar-icon' onClick={handleCalendarIconClick}>
          <svg className='custom-calendar-icon' width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M17.8125 1.87104L13.0583 1.87106V0.625146C13.0583 0.279753 12.7926 0 12.4646 0C12.1365 0 11.8708 0.279753 11.8708 0.625146V1.87075H7.12084V0.625146C7.12084 0.279753 6.85514 0 6.52709 0C6.19905 0 5.93334 0.279753 5.93334 0.625146V1.87075H1.1875C0.531703 1.87075 0 2.43057 0 3.12104V18.7497C0 19.4402 0.531703 20 1.1875 20H17.8125C18.4683 20 19 19.4402 19 18.7497V3.12104C19 2.43086 18.4683 1.87104 17.8125 1.87104ZM17.8125 18.7497H1.1875V3.12104H5.93334V3.75088C5.93334 4.09625 6.19905 4.37603 6.52709 4.37603C6.85514 4.37603 7.12084 4.09625 7.12084 3.75088V3.12136H11.8708V3.75119C11.8708 4.09658 12.1365 4.37634 12.4646 4.37634C12.7926 4.37634 13.0583 4.09658 13.0583 3.75119V3.12136H17.8125V18.7497ZM13.6562 9.99795H14.8438C15.1715 9.99795 15.4375 9.71788 15.4375 9.3728V8.12251C15.4375 7.77743 15.1715 7.49736 14.8438 7.49736H13.6562C13.3285 7.49736 13.0625 7.77743 13.0625 8.12251V9.3728C13.0625 9.71788 13.3285 9.99795 13.6562 9.99795ZM13.6562 14.9988H14.8438C15.1715 14.9988 15.4375 14.7191 15.4375 14.3737V13.1234C15.4375 12.7783 15.1715 12.4982 14.8438 12.4982H13.6562C13.3285 12.4982 13.0625 12.7783 13.0625 13.1234V14.3737C13.0625 14.7194 13.3285 14.9988 13.6562 14.9988ZM10.0938 12.4982H8.90625C8.5785 12.4982 8.3125 12.7783 8.3125 13.1234V14.3737C8.3125 14.7191 8.5785 14.9988 8.90625 14.9988H10.0938C10.4215 14.9988 10.6875 14.7191 10.6875 14.3737V13.1234C10.6875 12.7786 10.4215 12.4982 10.0938 12.4982ZM10.0938 7.49736H8.90625C8.5785 7.49736 8.3125 7.77743 8.3125 8.12251V9.3728C8.3125 9.71788 8.5785 9.99795 8.90625 9.99795H10.0938C10.4215 9.99795 10.6875 9.71788 10.6875 9.3728V8.12251C10.6875 7.77712 10.4215 7.49736 10.0938 7.49736ZM5.34375 7.49736H4.15625C3.8285 7.49736 3.5625 7.77743 3.5625 8.12251V9.3728C3.5625 9.71788 3.8285 9.99795 4.15625 9.99795H5.34375C5.6715 9.99795 5.9375 9.71788 5.9375 9.3728V8.12251C5.9375 7.77712 5.6715 7.49736 5.34375 7.49736ZM5.34375 12.4982H4.15625C3.8285 12.4982 3.5625 12.7783 3.5625 13.1234V14.3737C3.5625 14.7191 3.8285 14.9988 4.15625 14.9988H5.34375C5.6715 14.9988 5.9375 14.7191 5.9375 14.3737V13.1234C5.9375 12.7786 5.6715 12.4982 5.34375 12.4982Z" fill="#424242"/>
          </svg>
        </div>
      )}
      {displayErrors.length > 0 && (
        <div className="input-error-message fts-12">
          {displayErrors}
        </div>
      )}
    </div>
  );
};

export default InputBoxSmall;
